import { useState } from 'react';

const useExpandable = () => {
    const [isShown, setIsShown] = useState<boolean>(false);
    const toggle = () => {
        setIsShown(!isShown);
    };

    return {
        isShown,
        toggle,
    };
};

export default useExpandable;
